import {
    FETCHING_ALL_WORKSPACES,
    FETCHING_ALL_WORKSPACES_SUCCEEDED,
    FETCHING_ALL_WORKSPACES_FAILED,
    FETCHING_STORYBOARDS_REQUEST,
    FETCHING_STORYBOARDS_SUCCEEDED,
    FETCHING_STORYBOARDS_FAILED,
    ACTIVATING_CLEVERSTORY_WORKSPACE,
    ACTIVATING_CLEVERSTORY_WORKSPACE_SUCCEEDED,
    ACTIVATING_CLEVERSTORY_WORKSPACE_FAILED,
    FETCHING_ACTIVATED_WORKSPACES,
    FETCHING_ACTIVATED_WORKSPACES_SUCCEEDED,
    FETCHING_ACTIVATED_WORKSPACES_FAILED,
    FETCHING_PAGES_FROM_STORYBOARD,
    FETCHING_PAGES_FROM_STORYBOARD_SUCCEEDED,
    FETCHING_PAGES_FROM_STORYBOARD_FAILED,
    UPDATING_CLEVERSTORY_ASSET_METADATA,
    UPDATING_CLEVERSTORY_ASSET_METADATA_FAILED,
    UPDATING_CLEVERSTORY_ASSET_METADATA_SUCCEEDED,
    INVALIDATE_CLEVERSTORY_PAGE_CREATION,
  } from "../actionTypes.jsx";
  import axios from "axios";
  import buildUrl from "build-url-ts";
  import _ from 'lodash';

  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  const cleverstoryApiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}`;
  const CLEVERSTORY_BASE_URL = `${cleverstoryApiUrl}/api/1.0/integrations/cleverstory`;
  const DATASOURCE_BASE_URL = `${apiUrl}/api/2.0/datasources/cleverstory`
  const API_BASE_URL = `${apiUrl}/api/2.0`;
  const ASSETS_BASE_URL = `${API_BASE_URL}/assets`;

  export function fetchAllWorkspaces() {
    return function (dispatch) {
      dispatch(fetchingRequest(FETCHING_ALL_WORKSPACES));
      return axios({
        method: "GET",
        url: CLEVERSTORY_BASE_URL,
      }).then((response) =>
        dispatch(fetchingSucceeded(FETCHING_ALL_WORKSPACES_SUCCEEDED, response.data))
      ).catch((error) => dispatch(fetchingFailed(FETCHING_ALL_WORKSPACES_FAILED, error)));
    };
  }
  export function fetchStoryboards(workspaceId, request) {
    return function (dispatch) {
      dispatch(fetchingRequest(FETCHING_STORYBOARDS_REQUEST, workspaceId));
      var url = buildUrl(CLEVERSTORY_BASE_URL, {
        path: `${workspaceId}/storyboard`,
        queryParams: {
          query: _.get(request,"query",""),
          page: _.get(request,"page",0),
          limit: 10
        }
      });
      return axios({
        method: "GET",
        url: url,
      }).then((response) =>
        dispatch(fetchingSucceeded(FETCHING_STORYBOARDS_SUCCEEDED, response.data, workspaceId))
      ).catch((error) => dispatch(fetchingFailed(FETCHING_STORYBOARDS_FAILED, error, workspaceId)));
    };
  }
  export function activateWorkspace(workspaceId, workspaceName) {
    return function (dispatch) {
      dispatch(fetchingRequest(ACTIVATING_CLEVERSTORY_WORKSPACE, workspaceId));
      var url = buildUrl(DATASOURCE_BASE_URL, {
        path: `/authenticate`,
        queryParams: {
          code: JSON.stringify({
            workspace: workspaceId,
            workspaceName: workspaceName
          })
        }
      });
      return axios({
        method: "POST",
        url: url,
      }).then((response) =>
        dispatch(fetchingSucceeded(ACTIVATING_CLEVERSTORY_WORKSPACE_SUCCEEDED, response.data, workspaceId))
      ).catch((error) => dispatch(fetchingFailed(ACTIVATING_CLEVERSTORY_WORKSPACE_FAILED, error, workspaceId)));
    };
  }
  export function fetchActivatedWorkspaces() {
    return function (dispatch) {
      dispatch(fetchingRequest(FETCHING_ACTIVATED_WORKSPACES));
      return axios({
        method: "GET",
        url: DATASOURCE_BASE_URL,
      }).then((response) =>
        dispatch(fetchingSucceeded(FETCHING_ACTIVATED_WORKSPACES_SUCCEEDED, response.data))
      ).catch((error) => dispatch(fetchingFailed(FETCHING_ACTIVATED_WORKSPACES_FAILED, error)));
    };
  }
  export function fetchPagesForStoryboard(page, workspaceId, storyboardId) {
    return function (dispatch) {
      dispatch(fetchingRequest(FETCHING_PAGES_FROM_STORYBOARD, workspaceId, storyboardId));
      var url = buildUrl(CLEVERSTORY_BASE_URL, {
        path: `${storyboardId}/pages`,
        queryParams: {
          page: page ? page : 0,
          limit: 20
        }
      });
      return axios({
        method: "GET",
        url : url,
      }).then((response) =>
        dispatch(fetchingSucceeded(FETCHING_PAGES_FROM_STORYBOARD_SUCCEEDED, response.data, workspaceId, storyboardId))
      ).catch((error) => dispatch(fetchingFailed(FETCHING_PAGES_FROM_STORYBOARD_FAILED, error, workspaceId, storyboardId)));
    };
  }
  function fetchingRequest(type, workspaceId, storyboardId) {
    return {
      type,
      payload: {},
      workspaceId: workspaceId ? workspaceId : null,
      storyboardId: storyboardId ? storyboardId : null
    };
  }
  function fetchingSucceeded(type, response, workspaceId, storyboardId) {
    return {
      type,
      payload: response,
      workspaceId: workspaceId ? workspaceId : null,
      storyboardId: storyboardId ? storyboardId : null
    };
  }
  function fetchingFailed(type, error, workspaceId, storyboardId) {
    return {
      type,
      payload: error,
      workspaceId: workspaceId ? workspaceId : null,
      storyboardId: storyboardId ? storyboardId : null
    };
  }
  export const invalidateCleverstoryPageCreation = (assetId) => {
    return {
      type: INVALIDATE_CLEVERSTORY_PAGE_CREATION,
      payload: {
        assetId
      }
    }
  }
  export function updateCleverstoryAssetMetadata(assetId) {
    return function (dispatch) {
      dispatch(updatingCleverstoryAssetMetadata(assetId));
      let url = buildUrl(ASSETS_BASE_URL, {
        path: `cleverstory_page/${assetId}`
      });
      return axios({
        method: "put",
        url : url,
      }).then((response) =>
        dispatch(updatingCleverstoryAssetMetadataSucceeded(response.data, assetId))
      ).catch((error) => dispatch(updatingCleverstoryAssetMetadataFailed(error, assetId)));
    };
  }
  function updatingCleverstoryAssetMetadata(assetId){
    return {
      type: UPDATING_CLEVERSTORY_ASSET_METADATA,
      payload: {
        assetId
      }
    }
  }
  function updatingCleverstoryAssetMetadataSucceeded(response, assetId){
    return {
      type: UPDATING_CLEVERSTORY_ASSET_METADATA_SUCCEEDED,
      payload: {
        assetId,
        asset : response
      }
    }
  }
  function updatingCleverstoryAssetMetadataFailed(error, assetId){
    return {
      type: UPDATING_CLEVERSTORY_ASSET_METADATA_FAILED,
      payload: {
        assetId,
        error
      }
    }
  }
  
  
  
  
  
  
  